import script from "./Tos.vue?vue&type=script&setup=true&lang=js"
export * from "./Tos.vue?vue&type=script&setup=true&lang=js"

import "./Tos.vue?vue&type=style&index=0&id=f37de308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f37de308"]])

export default __exports__